<div fxLayout="column" fxLayoutAlign="start center">
  <div
    class="empty-state-image"
    fxFlex
    [style.backgroundImage]="'url(' + imagePath + ')'"
  ></div>
  <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="16px">
    <ng-content></ng-content>

    <div class="buttons">
      <ng-container *ngFor="let button of buttonText; let index = index">
        <ng-container [ngTemplateOutlet]="index === 0 ? primaryButton : secondaryButton"
                      [ngTemplateOutletContext]="{ button: button, index: index, buttonTooltip: buttonTooltip ? buttonTooltip[index] : null }">
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #secondaryButton let-button="button" let-index="index" let-toolTip="buttonTooltip">
  <button
    mat-stroked-button
    (click)="buttonClicked.emit(index)"
    [ngClass]="customClass"
    [matTooltip]="toolTip"
    fxLayout="row"
    fxLayoutAlign="center center"
    color="accent"
  >
    {{ button }}
  </button>
</ng-template>

<ng-template #primaryButton let-button="button" let-index="index" let-toolTip="buttonTooltip">
  <button
    mat-raised-button
    (click)="buttonClicked.emit(index)"
    [ngClass]="customClass"
    [matTooltip]="toolTip"
    fxLayout="row"
    fxLayoutAlign="center center"
    color="accent"
  >
    {{ button }}
  </button>
</ng-template>
